import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import style from "./Login.module.css";
import logo from "../../assets/Images/logo.png";

import { callAPI } from "../../assets/Js/backendCommunication";
import { Spinner } from "../../Components/Spinner/Spinner";
import { withRouter } from "react-router-dom";

import {
  getPlainToken,
  getUserData,
  setToken,
} from "../../assets/Js/tokenHandler";
import { setUserData } from "../../assets/Js/tokenHandler";
import { manageTrail, setUserGymData } from "../../assets/Js/localStorage";

import addGymData from "../../redux/actionCreators/addGymData";
import addUserData from "../../redux/actionCreators/addUserData";

import projectSettings from "../../assets/Js/projectSettings";

import { immediateToast } from "izitoast-react";
import { Gym_Not_Created } from "../../assets/Js/errorMessage";

import { apiResponseToast } from "../../assets/Js/apiResponseToast";
import { manageSubscription, setUserId } from "../../assets/Js/localStorage";
import { marketPlaceParam } from "../../assets/Js/paramName";

const mapDispatchToProps = (dispatch) => {
  return {
    addGymInfo: (data) => dispatch(addGymData(data)),
    addUserInfo: (data) => dispatch(addUserData(data)),
  };
};

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(
    class Login extends Component {
      constructor(props) {
        super(props);

        this.state = {
          email: "",
          password: "",
          isLoading: false,
          search: "",
          infoBox: false,
          gymName: "",
          trackName: "",
        };

        this.isAlreadyLoggedIn();
      }

      componentDidMount() {
        const paramName = marketPlaceParam;
        const search = this.props.location.search;
        const paramValue = new URLSearchParams(search).get(paramName);
        const gymName = new URLSearchParams(search).get("gymname");
        const trackName = new URLSearchParams(search).get("trackname");

        let isRequiredParams = false;
        isRequiredParams =
          search.includes("?" + paramName + "=") ||
          search.includes("&" + paramName + "=");
        this.setState({
          search,
          gymName,
          trackName,
          infoBox: isRequiredParams,
        });
      }

      isAlreadyLoggedIn = () => {
        const { search } = this.state;
        if (getPlainToken()) {
          const { Id, Image, Role } = getUserData();

          if (search) {
            this.props.history.push(
              `/trackjoiningpage${search}&userimage=${Image}&userid=${Id}`
            );
          } else {
            this.props.history.push("/dashboard");
          }
        }
      };

      submitHandler = (e) => {
        e.preventDefault();

        this.backendCommunication();
      };

      backendCommunication = async () => {
        let url = `${projectSettings.baseUrl}/users/login`;
        let header = true;
        let type = "POST";
        let data = {};
        let token = null;

        let { email, password } = this.state;
        data = {
          Email: email,
          Password: password,
        };

        let response = "";

        if (response === "") {
          this.setState({ isLoading: true });
        }

        response = await callAPI(
          url,
          header,
          type,
          JSON.stringify(data),
          token
        );

        if (response) {
          apiResponseToast(response.status, "login", response.data.message);

          this.setState({ isLoading: false });
          if (response.type === "error") {
          } else if (response.type === "success") {
            let token = response.data.Token;
            let expires = response.data.Expires;
            let userData = response.data.User;
            let userGymData = response.data.Gym || null;
            let tokenSaved;

            if (!response.data.Gym && response.data.User.Role === "owner") {
              this.hasCreatedGym(response.data.Gym, response.data.User);
            } else {
              setToken(token, expires);
              setUserData(userData);

              userGymData && setUserGymData(JSON.stringify(userGymData));
              this.props.addUserInfo(userData);

              if (response.data.User) {
                this.props.addUserInfo(response.data.User);
              }
              if (
                response.data.IsSubscribed ||
                response.data.User.Role === "athlete"
              ) {
                manageSubscription("false");
              } else {
                manageSubscription("true");
              }
              if (response.data.User.Role === "owner") {
                manageTrail(response.data.IsTrialEnd);
              }

              const { search } = this.state;
              const redirectUrl = new URLSearchParams(search).get(
                "redirecturl"
              );

              let { Image, Id, Role } = response.data.User;

              if (redirectUrl) {
                this.props.history.push(`${redirectUrl}`);
              } else if (search) {
                this.props.history.push(
                  `/trackjoiningpage${search}&userimage=${Image}&userid=${Id}`
                );
              } else {
                this.props.history.push("/dashboard");
              }
            }
            response = "";
          }
        }
      };

      hasCreatedGym = (hasGym, hasUser) => {
        if (!hasGym && hasUser) {
          if (hasUser.Role === "owner") {
            setUserId(hasUser.Id);
            setUserGymData("");
            immediateToast("warning", {
              message: Gym_Not_Created,
            });
            this.props.history.push(
              `/gymregistrationgymcreationform/${hasUser?.Id}`
            );
          }
        }
      };

      getRegisterLink = () => {
        const { search } = this.state;

        if (search) {
          return `/landingpage${search}`;
        } else {
          return "/landingpage";
        }
      };

      render() {
        return (
          <>
            <div className={style.container}>
              <div className={`${style.formContainer} shadow`}>
                <div className="logo">
                  <img src={logo} className="w-100" />
                </div>
                <hr />
                {this.state.infoBox && (
                  <div
                    class="alert alert-success alert-dismissible fade show mr-3 ml-4"
                    role="alert"
                  >
                    To continue joining
                  <strong>{`${this.state.gymName && this.state.trackName ? `your
                    ${this.state.gymName}'s ${this.state.trackName}
                  `:'' }
                 `}</strong>
                    , Please login using the email and password you just
                    created.
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                )}
                <form
                  className="forms-sample p-4"
                  onSubmit={this.submitHandler}
                >
                  <div className="formGroup">
                    <div className="mr-1">
                      <label htmlFor="userName">Email</label>
                      <input
                        type="email"
                        className="form-control form-control-sm"
                        id="userName"
                        placeholder="Email"
                        required
                        onChange={(e) =>
                          this.setState({ email: e.target.value })
                        }
                      />
                    </div>
                  </div>
                  <div className="formGroup">
                    <div className="mr-1">
                      <label htmlFor="password">Password</label>
                      <input
                        type="password"
                        className="form-control form-control-sm"
                        id="password"
                        placeholder="password"
                        required
                        onChange={(e) =>
                          this.setState({ password: e.target.value })
                        }
                      />
                    </div>
                  </div>
                  <div className="mx-auto width-fit-content mt-3">
                    <button
                      type="submit"
                      className="basicBtnStyle primaryBtn"
                      disabled={this.state.isLoading}
                    >
                      {this.state.isLoading ? <Spinner /> : <span>Login</span>}
                    </button>
                  </div>
                </form>
                <Link to="/forgotpassword">
                  <div className="h6 primaryColor text-center mb-3 pointerCursor">
                    Forgot password?
                  </div>
                </Link>
                <Link to={this.getRegisterLink}>
                  <div className="h6 primaryColor text-center mb-4 pointerCursor">
                    Create new account
                  </div>
                </Link>
              </div>
            </div>
            <div className="cornerBtnStyle">
              <Link to="/marketplace" className="text-white">
                <button className="basicBtnStyle secondaryBtn">
                  Marketplace
                </button>
              </Link>
            </div>
          </>
        );
      }
    }
  )
);
